import * as types from "../constants/actionConstants";
import TemplateApi from "../api/TemplateApi";
import {createEditorInstanceId, EDITOR_TYPES} from "../utilities/editorInstanceOwnership";

export function initializeEditorCreate() {
    //Should not be returning structure for initialize. Should be using the structure from the reducer
    return {
        type: types.ACTION_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.ACTION),
            template: {
                templateKey: "",
                name: "",
                nameQualifier: null,
                description: "",
                type: "",
                metadata: {}
            },
            options: {
                hasDescription: false,
                hasScript: false,
                createMode: true,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function initializeEditorUpdate(template) {
    return {
        type: types.ACTION_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.ACTION),
            template: template,
            options: {
                hasScript: !!template.script,
                hasDescription: !!template.description,
                createMode: false,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function updateTemplate(template, options) {
    return {
        type: types.ACTION_EDITOR_UPDATE,
        payload: {
            template,
            options
        }
    };
}

export function clearEditor() {
    return {
        type: types.ACTION_EDITOR_CLEAR
    };
}

export function validateActionNameUnique(name) {
    return (dispatch) => {
        dispatch({type: types.ACTION_EDITOR_NAME_VALIDATING});
        dispatch(checkActionNameExists(name))
    };
}

export function checkActionNameExists(filter) {
    let thunk = (dispatch) => {
        TemplateApi.checkActionNameExists(filter).then((data) => {
            dispatch({type: types.ACTION_EDITOR_NAME_EXISTS, list: data.collection});
        });
    };

    thunk.meta = {
        debounce: {
            time: 1000,
            key: "__actionExistsCheck",
            leading: false,
            trailing: true
        }
    };

    return thunk;
}

